/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ failed: NonNullable<unknown>, total: NonNullable<unknown> }} Applicants_Bulk_Partial_FailureInputs */

const en_applicants_bulk_partial_failure = /** @type {(inputs: Applicants_Bulk_Partial_FailureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.failed} of ${i?.total} could not be moved — check the list`)
};

const de_applicants_bulk_partial_failure = /** @type {(inputs: Applicants_Bulk_Partial_FailureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.failed} von ${i?.total} konnten nicht verschoben werden — Liste prüfen`)
};

/**
* | output |
* | --- |
* | "{failed} of {total} could not be moved — check the list" |
*
* @param {Applicants_Bulk_Partial_FailureInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicants_bulk_partial_failure = /** @type {((inputs: Applicants_Bulk_Partial_FailureInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applicants_Bulk_Partial_FailureInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicants_bulk_partial_failure(inputs)
	return en_applicants_bulk_partial_failure(inputs)
});